import { CheckIcon } from '@heroicons/react/20/solid';

import { Button } from '@/components/Button';
import { ModalComponent } from '@/components/ModalComponent';
import { RemoteImage } from '@/components/RemoteImage';
import { EDisplays, EModals, setDisplay, setModal } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';
import { useCopy } from '@/copy';

export const testId = 'ApplicationSubmitted';
const baseId = 'modal-applicationSubmitted';

export function ApplicationSubmitted(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    const { plainSubmittedModal, applicationSubmitted } = useCopy();

    // ***** Handlers *****
    function handleClick(): void {
        /**
         * Returning from a submitted application should land on the journey's
         * home screen. The default sends the customer to Your details with an
         * in-progress modal over it, which reads as the form starting again
         * right after they finished it.
         */
        if (plainSubmittedModal) {
            dispatch(setModal(null));
            dispatch(setDisplay(EDisplays.QUICK_CALCULATOR));
            return;
        }

        dispatch(setDisplay(EDisplays.BASIC));
        dispatch(setModal(EModals.APPLICATION_IN_PROGRESS));
    }

    // ***** Render *****
    if (plainSubmittedModal) {
        return (
            <ModalComponent
                baseId={baseId}
                className='px-8'
                data-testid={testId}
            >
                {/* The same mark the affordability pass uses, so the two
                    good-news moments in the journey look like a pair. Left
                    aligned to match it: a centred column of three different
                    line lengths had no edge to read down. */}
                <div className='h-12 w-12 rounded-full flex-center bg-reassureBg text-reassureText mt-2'>
                    <CheckIcon className='h-6 w-6' />
                </div>
                <h3 className='font-bold text-[22px] pt-4'>
                    {applicationSubmitted.title}
                </h3>
                <div className='_flex flex-col gap-2 pt-3 pb-6'>
                    {applicationSubmitted.body.map((line, index) => (
                        <p
                            key={`applicationSubmittedBody-${index}`}
                            className='text-sm text-textBody'
                        >
                            {line}
                        </p>
                    ))}
                </div>
                <div className='-mx-4'>
                    <Button id={`${baseId}-button-close`} onClick={handleClick}>
                        <p>{applicationSubmitted.cta}</p>
                    </Button>
                </div>
            </ModalComponent>
        );
    }

    return (
        <ModalComponent baseId={baseId} className='px-8' data-testid={testId}>
            <RemoteImage fileName='confetti.svg' className='w-full h-40' />
            <h3 className='text-center font-bold text-[26px]'>
                Congratulations!
            </h3>
            <p className='-mt-8 pb-4 font-semi-bold text-lg text-center text-textBody'>
                <br />
                Your application has
                <br />
                been sent!
            </p>

            <p className='p-3 text-textBody  font-semi-bold text-sm _flex flex-col justify-center align-middle items-center text-center border border-primary rounded-lg'>
                <strong> Don&apos;t worry, we&apos;ll stay in touch. </strong>
                One of our friendly team will be in <br />
                touch with you shortly.
            </p>
            <div className='mt-10 -mx-4'>
                <Button id={`${baseId}-button-close`} onClick={handleClick}>
                    <p>Close</p>
                </Button>
            </div>
        </ModalComponent>
    );
}
